import { render, staticRenderFns } from "./CouponUsageLogTable.vue?vue&type=template&id=55fbfa52"
import script from "./CouponUsageLogTable.vue?vue&type=script&lang=js"
export * from "./CouponUsageLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports